//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// resourceConcern
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export class ResourceConcern {


    //resource concern component fields
    resource_concern_component_description = "";
    resource_concern_component_name = "";
    resource_concern_component_display = "";
    resource_concern_component_start_date = null;
    resource_concern_component_end_date = null;
    resource_concern_component_publish = false;

    //resource concern fields
    resource_concern_category_id = 0;
    swapa_category_id = 0;
    resource_concern_description = "";
    resource_concern_display = "";
    resource_concern_id = 0;
    resource_concern_name = "";
    resource_concern_end_date = null;
    resource_concern_start_date = null;
    resource_concern_publish = false;


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //constructor(){};
}